exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ozIagrHl9JNPkQJdJH8O9{font-size:12px;font-weight:400;height:24px;color:\"[theme:themeDarkAlt, default:#005A9E]\"}html[dir] .ozIagrHl9JNPkQJdJH8O9{border-radius:4px;padding:0}.ozIagrHl9JNPkQJdJH8O9:active,.ozIagrHl9JNPkQJdJH8O9:hover{color:\"[theme:themeDarkAlt, default:#005A9E]\"}._3zEUHyEmv1xsSyrtyZtpaP{font-size:12px;font-weight:400}html[dir] ._3zEUHyEmv1xsSyrtyZtpaP{margin:1px 0 0 0}", ""]);
// Exports
exports.locals = {
	"viewEmailButton": "ozIagrHl9JNPkQJdJH8O9",
	"emailIcon": "_3zEUHyEmv1xsSyrtyZtpaP"
};